import BaseModel from './base'

class Interest extends BaseModel {
  constructor(options, currentuser) {
    const isLiked = options.liker_ids.includes(currentuser?.id)

    const defaults = {
      id: null,
      name: null,
      slug: null,
      state: null,
      likesCount: 0,
      visitCount: 0,
      liked: isLiked,
      creatorId: null,
      likerIds: [],
      lastLikeAt: null,
      lastVisitAt: null,
      visitedAt: null,
      createdAt: null,
      updatedAt: false,
      className: 'interest',
      blockType: 'InterestBlock',
    }

    super(options, defaults)
  }
}

export { Interest as default }
